import { getFormId, getFormName, getSource, getSourceId, getObjectId, getObjectName
// @ts-expect-error module not typed
} from 'conversations-message-history/crm-object-lifecycle-update/operators/crmObjectLifecycleUpdateGetters';
// @ts-expect-error module not typed
import { isFormSubmission } from 'conversations-message-history/crm-object-lifecycle-update/operators/isFormSubmission';
// @ts-expect-error module not typed
import { isSystemUpdate } from 'conversations-message-history/crm-object-lifecycle-update/operators/isSystemUpdate';
import SkeletonText from 'conversations-skeleton-state/components/SkeletonText';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FullSenderName from '../senders/components/FullSenderName';
import { findSender } from 'conversations-message-history/senders/operators/findSender';
import { getData } from 'conversations-message-history/senders/operators/getters';
// @ts-expect-error module not typed
import { isSenderLoading } from 'conversations-message-history/senders/operators/isSenderLoading';
// @ts-expect-error module not typed
import FormLink from './FormLink';
import { Button } from 'foundations-components/transitional/components/Button';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ThreadCrmTicketCreatedHeader = ({
  message,
  senders,
  userId,
  portalId
}) => {
  const senderId = getSourceId(message);
  const senderType = getSource(message);
  const asyncSender = findSender(senderId, senderType, senders);
  const objectId = getObjectId(message);
  if (isSenderLoading(asyncSender)) {
    return /*#__PURE__*/_jsx(SkeletonText, {
      inlineSize: "150px"
    });
  }
  if (senderId === userId) {
    return /*#__PURE__*/_jsx("span", {
      children: /*#__PURE__*/_jsxs(Text, {
        typography: "detail-100",
        color: "text-core-subtle",
        marginBlockStart: "50",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-inbox-message-history.crm-ticket-lifecycle-update.threadCreateHeader.currentAgent"
        }), /*#__PURE__*/_jsx(Button, {
          href: `/contacts/${portalId}/ticket/${objectId}`,
          external: true,
          size: 'extra-small',
          use: "tertiary-light",
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "conversations-inbox-message-history.crm-ticket-lifecycle-update.threadCreate",
            options: {
              ticketName: /*#__PURE__*/_jsx("b", {
                children: getObjectName(message)
              }),
              link: `#${objectId}`
            }
          })
        })]
      })
    });
  }
  if (isFormSubmission(message)) {
    return /*#__PURE__*/_jsx("span", {
      children: /*#__PURE__*/_jsxs(Text, {
        typography: "detail-100",
        color: "text-core-subtle",
        marginBlockStart: "50",
        children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "conversations-inbox-message-history.crm-ticket-lifecycle-update.threadCreateHeader.formSubmission",
          options: {
            formName: /*#__PURE__*/_jsx(FormLink, {
              formName: getFormName(message),
              formId: getFormId(message),
              portalId: portalId
            })
          }
        }), /*#__PURE__*/_jsx(Button, {
          href: `/contacts/${portalId}/ticket/${objectId}`,
          external: true,
          size: 'extra-small',
          use: "tertiary-light",
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "conversations-inbox-message-history.crm-ticket-lifecycle-update.create",
            options: {
              ticketName: /*#__PURE__*/_jsx("b", {
                children: getObjectName(message)
              }),
              link: `#${objectId}`
            }
          })
        })]
      })
    });
  }
  if (isSystemUpdate(message)) {
    return /*#__PURE__*/_jsx("span", {
      children: /*#__PURE__*/_jsxs(Text, {
        typography: "detail-100",
        color: "text-core-subtle",
        marginBlockStart: "50",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-inbox-message-history.crm-ticket-lifecycle-update.threadCreateHeader.system"
        }), /*#__PURE__*/_jsx(Button, {
          href: `/contacts/${portalId}/ticket/${objectId}`,
          external: true,
          size: 'extra-small',
          use: "tertiary-light",
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "conversations-inbox-message-history.crm-ticket-lifecycle-update.create",
            options: {
              ticketName: /*#__PURE__*/_jsx("b", {
                children: getObjectName(message)
              }),
              link: `#${objectId}`
            }
          })
        })]
      })
    });
  }
  return /*#__PURE__*/_jsx("span", {
    children: /*#__PURE__*/_jsxs(Text, {
      typography: "detail-100",
      color: "text-core-subtle",
      marginBlockStart: "50",
      children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "conversations-inbox-message-history.crm-ticket-lifecycle-update.threadCreateHeader.agent",
        options: {
          agent: /*#__PURE__*/_jsx("b", {
            children: /*#__PURE__*/_jsx(FullSenderName, {
              sender: asyncSender && getData(asyncSender)
            })
          })
        }
      }), /*#__PURE__*/_jsx(Button, {
        href: `/contacts/${portalId}/ticket/${objectId}`,
        external: true,
        use: "tertiary-light",
        size: 'extra-small',
        children: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "conversations-inbox-message-history.crm-ticket-lifecycle-update.create",
          options: {
            ticketName: /*#__PURE__*/_jsx("b", {
              children: getObjectName(message)
            }),
            link: `#${objectId}`
          }
        })
      })]
    })
  });
};
ThreadCrmTicketCreatedHeader.displayName = 'ThreadCrmTicketCreatedHeader';
export default ThreadCrmTicketCreatedHeader;